module.exports = __webpack_public_path__ + "img/aprobado.187526db.png";